<template>
  <div class="account-notifications">
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th width="100"><a href="javascript:;">DATE</a></th>
          <th width="100"><a href="javascript:;">JOB REQUEST NO</a></th>
          <th width="20%"><a href="javascript:;">COMPANY</a></th>
          <th>TITLE</th>
          <th>STATUS</th>
          <th width="10"></th>
        </tr>
        </thead>
        <tbody>
        <template v-if="totalItems" >
          <tr v-for="(request, index) in jobRequests" :key="index" :class="{'unread': request.status == 'pending'}" @click="viewRequest(index)" style="cursor: pointer;">
            <td>{{ request.request_date | toHumanDate('DD.MM.YYYY') }}</td>
            <td>{{ (request.client?request.client.code:'') + request.id }}</td>
            <td v-if="!IS_CLIENT">{{ request.client.name }}</td>
            <td>{{ request.name }}</td>
            <td>{{ request.status | statusToUCWords }}</td>
            <td><span></span></td>
          </tr>
        </template>
        <tr v-else-if="!loading"><td colspan="5">No requests for job</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServiceJobRequest from '@/services/jobrequest'
  import ModalViewRequest from './ModalViewRequest';

  export default {
    data () {
      return {
        loading: false,
        jobRequests: [],
        totalItems: 0
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['IS_CLIENT', 'CURRENT_USER'])
    },
    mounted () {
      this.init();
    },
    methods: {
      init() {
        this.getJobs();
      },
      _getParams(){
        let self = this,
          params = {
            ipp: 'all'
          };

        if(self.IS_CLIENT){
          params['client_id'] = self.CURRENT_USER.client_id;
        }
        return params;
      },
      getJobs () {
        let self = this, params = self._getParams();
        self.loading = true;
        ServiceJobRequest.getJobRequests(params, resp => {
          self.jobRequests = resp;
          self.loading = false;
          self.totalItems = window.numkeys(self.jobRequests);
        });
      },
      viewRequest(index) {
        let self = this;
        self.notificating_id = index;
        self.$modal.show(ModalViewRequest, {
          request: self.jobRequests[index]
        }, {
          clickToClose: false,
          width: 592
        }, {
          'on-rejected' ( req ) {
            self.jobRequests.splice( index, 1, req );
          },
          'on-deleted' (  ) {
            self.jobRequests.splice( index, 1 );
          }
        });
      }
    }
  }
</script>
